import type { SandboxAuditThreadSummary } from "@/api/sandboxAudit";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { formatAuditTime, modelLabel } from "./format";

type Props = {
  threads: SandboxAuditThreadSummary[];
  isLoading: boolean;
  selectedId: number | null;
  onOpen: (thread: SandboxAuditThreadSummary) => void;
};

export function AuditThreadList({ threads, isLoading, selectedId, onOpen }: Props) {
  return (
    <Table>
      <TableHeader className="sticky top-0 z-10 bg-muted">
        <TableRow>
          <TableHead>Thread</TableHead>
          <TableHead>Person</TableHead>
          <TableHead>Model</TableHead>
          <TableHead className="text-right">Started</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {isLoading &&
          threads.length === 0 &&
          [0, 1, 2].map((row) => (
            <TableRow key={row}>
              <TableCell colSpan={4}>
                <Skeleton className="h-6 w-full" />
              </TableCell>
            </TableRow>
          ))}
        {!isLoading && threads.length === 0 && (
          <TableRow>
            <TableCell colSpan={4} className="py-10 text-center text-muted-foreground">
              No threads match these filters.
            </TableCell>
          </TableRow>
        )}
        {threads.map((thread) => (
          <TableRow
            key={thread.id}
            data-state={selectedId === thread.id ? "selected" : undefined}
            className="cursor-pointer"
            onClick={() => onOpen(thread)}
          >
            <TableCell className="max-w-[28rem]">
              <Button
                type="button"
                variant="link"
                className="h-auto max-w-full justify-start truncate p-0 text-left font-medium text-foreground"
                onClick={(event) => {
                  event.stopPropagation();
                  onOpen(thread);
                }}
              >
                {thread.title}
              </Button>
            </TableCell>
            <TableCell className="text-muted-foreground">{thread.user_email ?? "Unknown person"}</TableCell>
            <TableCell className="text-muted-foreground">{modelLabel(thread)}</TableCell>
            <TableCell className="whitespace-nowrap text-right text-muted-foreground">
              {formatAuditTime(thread.created_at)}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
